import { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import {jwtDecode} from 'jwt-decode';

import '../styles/pages/page-auth.css'

// AMPLIFY
import { generateClient } from 'aws-amplify/api';
import * as subscriptions from '../graphql/subscriptions';
import { createUserStatus, updateUserStatus } from '../graphql/mutations';
import { listUserStatuses } from '../graphql/queries';


import { useAuth } from '../contexts/AuthContext';
import useModelData from '../hooks/useModelData';
import BackdropModalSmall from '../components/modals/backdrop_modal_small';
import { Link } from 'react-router-dom';
import useResendVerificationEmail from '../hooks/useResendVerificationEmail';


// RECAPTCHA
const recaptchaSiteKey = "6LcR4kEsAAAAAB36S-CLO75JwDPiudJlx-fZ-9J4";

const Login = () => {

    // GET CURRENT LOCATION OF LAWYER
    const [location, setLocation] = useState(null);
    const [errorLocation, setErrorLocation] = useState(null);
  
    useEffect(() => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLocation({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          },
          (error) => {
            setErrorLocation(error.message);
          }
        );
      } else {
        setErrorLocation("Geolocation is not supported");
      }
    }, []);
  

  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const { user,login } = useAuth();
  const lawyerId = user.user_id;


   // Generate the API client
   const client = generateClient();

 

   const createUserStatusHandler = async (user_profile_id, full_name, user_profile_photo,email,mobile) => {
    const input = {
      user_profile_id: user_profile_id,
      user_status: 1,
      full_name: full_name,
      user_profile_photo: user_profile_photo,
      user_location: location,
      email_address:email,
      mobile_number:mobile
    };

    const filter = { user_profile_id: { eq: user_profile_id } };  // Dynamic filter object

    try {
      // Step 1: Check if the user already exists
      const existingStatus = await checkItemExists(listUserStatuses, filter);

      if (existingStatus) {
        console.log('User status already exists, updating...');

        // Step 2: If the user exists, get the ID and update the user status
        const updateInput = {
          id                : existingStatus.id,
          user_status       : 1,
          full_name         : full_name,
          user_profile_photo: user_profile_photo,
          user_location     : location
        };

        // Step 3: Call the updateItem function
        await updateItem(updateInput);
        console.log('User status updated successfully',existingStatus.id);
      } else {
        // Step 3: If user doesn't exist, create a new user status
       const gg = await createItem(input);


        console.log('User status created successfully');
      }
    } catch (error) {
      console.error('Error handling user status:', error);
    }
  };

  //  const createUserStatusHandler = async (user_profile_id, full_name,user_profile_photo) => {

  //   const input = {
  //     user_profile_id   : user_profile_id,
  //     user_status       : 1,
  //     full_name         : full_name,
  //     user_profile_photo: user_profile_photo,
  //     user_location     : location,
  //   };
  
  //   const variables = { user_profile_id };  // Variables to check if the user already exists
  //   console.log("variables",variables);
  
  //   try {
  //     // Step 1: Check if the user already exists
  //     const checkResponse = await client.graphql({
  //       query: listUserStatuses,
  //       variables: variables,
  //     });
  


  //   if (checkResponse.data.listUserStatuses.items.length > 0) {
  //     console.log('User status already exists, updating...');

  //     // Step 2: If the user exists, get the ID and update the user status
  //     const existingStatus = checkResponse.data.listUserStatuses.items[0];  // Take the first item (you may need to adjust if there are multiple)

  //     // Define the update mutation variables
  //     const updateVariables = {
  //       input: {
  //         id: existingStatus.id,  // The ID of the existing user status
  //         user_status: 1,  // New status to update
  //       },
  //       condition: {
  //         user_profile_id: { eq: user_profile_id },  // The condition to ensure we update the correct user
  //       },
  //     };

  //     // Step 3: Call the update mutation
  //     const updateResponse = await client.graphql({
  //       query: updateUserStatus,  // The mutation to update the user status
  //       variables: updateVariables,
  //     });

  //     console.log('User status updated:', updateResponse.data.updateUserStatus);
  //     return;
  //   }

  //     // Step 3: If user doesn't exist, create a new user status
  //     const mutationVariables = { input };
  //     const mutationResponse = await client.graphql({
  //       query: createUserStatus,
  //       variables: mutationVariables,
  //     });
  
  //     console.log('User status created:', mutationResponse.data.createUserStatus);
  
  //   } catch (error) {
  //     console.error('Error handling user status:', error);
  //   }
  // };


  const { dataAmplify, loadingAmplify, createItem, updateItem,checkItemExists } = useModelData({
    model: "UserStatus",
    queries: {
      // list: listUserStatuses,
      list: null,
      create: createUserStatus,
      update: updateUserStatus,
      //delete: deleteUserStatus,
    },
    subscriptions: {
      onCreate: subscriptions.onCreateUserStatus,
      onUpdate: subscriptions.onUpdateUserStatus,
      onDelete: null,
    },
    filter: {},
  });

    useEffect(() => {
      console.log("dataAmplify", dataAmplify);
    }, [dataAmplify]);

 

 

  const [error,setError] = useState(false)
  // const cookies = new Cookies();


  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpCode, setOtpCode] = useState('');

  // Temporary user credentials stored for OTP verification
  const [tempUserData, setTempUserData] = useState({
    email: '',
    username: '',
    password: '',
  });

  // Handle OTP modal close
  const handleClose = () => {
    setShowOtpModal(false);
    setOtpCode('');
  };

  // Handle OTP verify/save
  const handleSave = async () => {
    try {
      // call your verify OTP API here
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/verify-otp/`, {
        username: tempUserData.username,
        otp_code: otpCode,
      });

      if (response.data.success) {
        // OTP verified, now do the normal login process with tokens
        const { access_token, refresh_token, user_details } = response.data;
        login({ access_token, refresh_token, user_details });
        setShowOtpModal(false);
      } else {
        alert('Invalid OTP. Please try again.');
      }
    } catch (err) {
      alert('OTP verification failed.');
    }
  };

  



  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorAuth,setErrorAuth]= useState("");
  const [cooldown, setCooldown] = useState(0); // seconds remaining

  const { resendEmail, response:responseResendEmail, error:errorResendEmail, loading } = useResendVerificationEmail();


  const handleSubmit = async (e) => {
    setErrorAuth("");

    e.preventDefault();
    setIsSubmitting(true);
    setError(false);

    if (!recaptchaToken) {
      alert("Refresh the Page!");
      return;
    }

    try {
    
      const response = await axios.post( `${process.env.REACT_APP_API_URL}/login/`,
      {
        username,
        password,
        recaptchaToken,
      },
      {
        headers: {
          "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
        },
      }
    );




      const { access_token, refresh_token, user_details, requires_otp, email } = response.data;


    

       if (requires_otp) {
        setTempUserData({ email, username, password }); // save for OTP verification
        setShowOtpModal(true);  // show modal instead of redirect
        setIsSubmitting(false);
        return;
      }
      const decodedToken = jwtDecode(access_token);
      login({ access_token, refresh_token, user_details });

      // update status on Amplify
      const full_name = `${decodedToken.first_name} ${decodedToken.last_name}`;
      createUserStatusHandler(decodedToken.user_id, full_name, decodedToken.user_profile_photo, decodedToken.email, decodedToken.mobile_number);
      setErrorAuth("");
      setIsAuthenticated(true);
    } catch (err) {
      console.error('Login error:', err);
      setErrorAuth(err.response.data.detail)
      setError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

    // Countdown timer
  useEffect(() => {
    let interval;
    if (cooldown > 0) {
      interval = setInterval(() => {
        setCooldown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [cooldown]);

  const handleResendEmail = () => {
    if (username && cooldown === 0) {
      resendEmail(username);
      setCooldown(120); // 2 minutes
    }
  };
 


  // RECAPTCHA
    // Run reCAPTCHA v3 when the component mounts
  useEffect(() => {
    // Load the reCAPTCHA script dynamically when the component mounts
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
    script.async = true;
    script.onload = () => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(recaptchaSiteKey, { action: "login" })
          .then((token) => {
            setRecaptchaToken(token); // Store the token for the backend
          })
          .catch((error) => {
            console.error("reCAPTCHA error:", error);
          });
      });
    };
    document.body.appendChild(script);

    return () => {
      // Clean up the script when the component unmounts
      const scriptTag = document.querySelector(`script[src="${script.src}"]`);
      if (scriptTag) {
        scriptTag.remove();
      }
    };
  }, []);

  return (<>





<div className="authentication-wrapper authentication-cover">
  <a href="index.html" className="app-brand auth-cover-brand gap-2">
    
  </a>
  <div className="authentication-inner row m-0">
    <div className="d-none d-lg-flex col-lg-7 col-xl-8 align-items-center p-5">
      <div className="w-100 d-flex justify-content-center">

        <div className="container">
                <div className="row">
                    <div className="text-start col-lg-6 col-md-12 col-sm-12 col-xs-12" data-scroll-reveal="enter left move 30px over 0.6s after 0.4s" data-scroll-reveal-id="1" data-scroll-reveal-initialized="true" data-scroll-reveal-complete="true">
                        <h1>Remote  <em>Notarization </em>Technology</h1>
                        <h3>"Online Notaryo para sa lahat."</h3> <br/>
                        <a href="#about" className="main-button-slider">KNOW US BETTER</a>
                    </div>
                </div>
            </div>


        {/* <img src="../../assets/img/illustrations/boy-with-rocket-light.png" className="img-fluid" alt="Login image" width={700} data-app-dark-img="illustrations/boy-with-rocket-dark.png" data-app-light-img="illustrations/boy-with-rocket-light.png" /> */}
      </div>
    </div>
    <div className="d-flex col-12 col-lg-5 col-xl-4 align-items-center authentication-bg p-sm-12 p-6">
      <div className="w-px-400 mx-auto mt-12 pt-5">
        <h4 className="mb-1">Hi!</h4>
        <p className="mb-6">Sign-in to your account.</p>


           <form className="mb-3" onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email</label>

                <input
                  id="email"
                  type="text"
                  className="form-control"
                  placeholder="Enter your email or username"
                  value={username}
                  onChange={(e) => setUserName(e.target.value)}
                  required
                  autoFocus
                />

              </div>
              <div className="mb-3 form-password-toggle">
                <div className="d-flex justify-content-between">
                  <label className="form-label" htmlFor="password">Password</label>
                  <Link to="/forgot-password" id="password"><small className='text-warning'>Forgot Password?</small></Link>
                </div>
                <div className="input-group input-group-merge">

                  <input
                    id="password"
                    type="password"
                    className="form-control"
                    placeholder="············"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    aria-describedby="password"
                    required
                  />

                  <span className="input-group-text cursor-pointer"><i className="bx bx-hide" /></span>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="remember-me" />
                  <label className="form-check-label" htmlFor="remember-me"> Remember Me </label>
                </div>
              </div>
              
              <button className="btn btn-warning  w-100" type="submit" disabled={isSubmitting}>
                {isSubmitting ?
                  <><span className="spinner-grow me-1" role="status" aria-hidden="true"></span>Logging In...</>
                  :
                  <><span  className="" role="status" aria-hidden="true"></span>Sign In</>
                }
              </button>
              
            </form>
            <p className="text-center">

            <Link to="/register"> <span className='text-warning'>Create your account</span></Link>



              {/* <a href="auth-register-cover.html">
                <span>Create an account</span>
              </a> */}
            </p>


            {errorAuth && (
                <div>
                  <div className="alert alert-danger alert-dismissible fs-5" role="alert">
                    <p className="mb-0">{errorAuth === "not verified" ?
                    <>
                      Account not yet verified. Please check your inbox, all mails (and spam folder) and click the link we've sent you to verify your account.
                    <span onClick={handleResendEmail} className="text-primary" style={{ cursor: cooldown === 0 ? "pointer" : "not-allowed", opacity: cooldown === 0 ? 1 : 0.5 }} >
                        {loading
                          ? " Sending..."
                          : cooldown > 0
                            ? ` Resend in ${cooldown}s`
                            : " Resend Email"}
                      </span>
                    </>
                      :
                      errorAuth}</p>
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" />
                  </div>
                </div>
              )}
  
       
       
      </div>
    </div>
  </div>
</div>








    {/* MODAL */}
    <BackdropModalSmall open={showOtpModal} handleClose={handleClose} handleSave={handleSave} modalTitle="Enter OTP to Verify" >
      <div>
        <p>Enter the OTP sent to your email: <strong>{tempUserData.email}</strong></p>

        <input
          type="text"
          maxLength={6}
          className="form-control my-3"
          value={otpCode}
          onChange={(e) => setOtpCode(e.target.value)}
          placeholder="Enter OTP"
          autoFocus
        />

        <div className="d-flex justify-content-end">
          <button type="button" onClick={handleSave} className="btn btn-primary" disabled={!otpCode || otpCode.length !== 6} >
            Submit OTP
          </button>
        </div>
      </div>
    </BackdropModalSmall>
  </>

  );
};

export default Login;
